import { Action } from '@ngrx/store'
import { Area } from '../models'

export const INIT_AREAS_ON_VIDEO = '[Event] Init Areas On Video'
export const LOAD_AREAS_ON_VIDEO = '[Event] Load Areas On Video'
export const ADD_AREA_ON_VIDEO = '[Event] Add Area On Video'
export const REMOVE_AREA_ON_VIDEO = '[Event] Remove Area On Video'

export const INIT_AREAS_ON_STATIC_CONTENT = '[Event] Init Areas On Static Content'
export const LOAD_AREAS_ON_STATIC_CONTENT = '[Event] Load Areas On Static Content'
export const ADD_AREA_ON_STATIC_CONTENT = '[Event] Add Area On Static Content'
export const REMOVE_AREA_ON_STATIC_CONTENT = '[Event] Remove Area On Static Content'

export class InitVideoAreas implements Action {
  readonly type = INIT_AREAS_ON_VIDEO

  constructor() { }
}

export class LoadVideoAreas implements Action {
  readonly type = LOAD_AREAS_ON_VIDEO

  constructor(public videoId: number, public areas: Area[]) { }
}

export class AddVideoArea implements Action {
  readonly type = ADD_AREA_ON_VIDEO

  constructor(public area: Area) { }
}

export class RemoveVideoArea implements Action {
  readonly type = REMOVE_AREA_ON_VIDEO

  constructor(public areaId: number) { }
}

export type VideoAll
  = InitVideoAreas
  | LoadVideoAreas
  | AddVideoArea
  | RemoveVideoArea

export class InitStaticContentAreas implements Action {
  readonly type = INIT_AREAS_ON_STATIC_CONTENT

  constructor() { }
}

export class LoadStaticContentAreas implements Action {
  readonly type = LOAD_AREAS_ON_STATIC_CONTENT

  constructor(public staticContentId: number, public areas: Area[]) { }
}

export class AddStaticContentArea implements Action {
  readonly type = ADD_AREA_ON_STATIC_CONTENT

  constructor(public area: Area) { }
}

export class RemoveStaticContentArea implements Action {
  readonly type = REMOVE_AREA_ON_STATIC_CONTENT

  constructor(public areaId: number) { }
}

export type StaticContentAll
  = InitStaticContentAreas
  | LoadStaticContentAreas
  | AddStaticContentArea
  | RemoveStaticContentArea

export type All
  = VideoAll
  | StaticContentAll



// WEBPACK FOOTER //
// ./src/actions/area.ts